
/**多语言配置说明 https://segmentfault.com/a/1190000014229902 */
//法国

export const lang ={
  Please_set_materialtype_in_product_page:"Merci de vous rendre sur la page produit pour modifier et paramétrer le type de matière de chaque produit - produits finis - produits semi-finis - accessoires.",
deleteAccount:"Se déconnecter",
deleteAccountWillDeleteAllData:"La déconnexion de votre compte supprimera toutes les données et vous empêchera de vous connecter.",
backupDatabase:"base de données de sauvegarde",
restoreDatabase:"Restaurer la base de données",
materialtype:"Type de materiau",
Manufacturing:"Version de fabrication",
Professional:"Version professionnelle",
Standard:"édition standard",
product:"Produit fini",
halfProduct:"Produits semi-finis",
components:"Accessoires",
Parent:"composant parent",
Children:"Sous-accessoires",
Level:"Hiérarchie",
Timing:"Horaire",
PieceCount:"Travail à la pièce",
Wages:"Salaires",
InternalProcess:"Processus interne",
ExternalProcess:"processus externe",
ProceName:"Nom du processus",
ProceIndex:"Ordre d'exécution",
ChargeMan:"principal",
BillMethod:"Mode de facturation",
ConsumTime:"heures d'ouverture",
Accessories:"Accessoires",
Assembly:"Assembler",
materials:"matériaux",
task:"Tâche",
process:"processus",
BOM:"Nomenclature",
Production:"Production",
RestorePurchaseOneUse:"Restaurer l'achat (un utilisateur (limité aux achats précédents))",
buy_fail_try_again:"Veuillez cliquer à nouveau pour acheter",
Export:"Exporter",
Date:"date",
BankDetail:"coordonnées bancaires",
Seller:"vendeur",
Buver:"acheteur",
Currency:"devise",
CompanyName:"Nom de l'entreprise",
ProformaInvoice:"facture pro forma",
Discount:"Rabais",
PayStatus:"Statut de paiement",
ShippingStatus:"Statut d'envoi",
FreightType:"Type de transport",
Shipping:"fret",
Payment:"Paiement",
Moneyname:"nom de la devise",
Tax:"impôts",
Freight:"Frais de transport",
Insurance:"assurance",
Bankfee:"frais bancaires",
Qc:"Certification de qualité",
Exchangerate:"taux de change",
Shippingnumber:"numéro d'expédition",
ShipDate:"Date d'expédition",
Arrivedate:"date d'arrivée",
Grossweight:"poids brut",
CubicWeight:"poids cube",
Totalpackages:"Nombre total de colis",
Moneytype:"type de devise",
Quotedate:"date du devis",
Validitydate:"Date valide",
Paymentterm:"expiration du salaire",
Priceterm:"conditions de tarification",
DeliveryTerm:"Délai de livraison",
BankName:"Nom de banque",
BankAddress:"adresse de la banque",
SwiftCode:"Code bancaire",
Review:"Revoir",
Signfor:"Signer pour recevoir",
Finance:"finance",
Receiver:"Destinataire",
Business:"entreprise",
ContactPerson:"Personne de contact",
Profit:"profit",
Staff_must_use_in_browser_please_check_the_address_in_help_page:"Les employés doivent utiliser Google Chrome. Veuillez vérifier l'adresse IP sur la page d'aide de l'application de l'ordinateur de service principal, puis entrez l'adresse dans la colonne URL des autres navigateurs informatiques pour ouvrir la connexion.",
newPassword:"nouveau mot de passe",
ForgetPassword:"oublier le mot de passe",
ContactUs:"Contactez-nous/faites des suggestions",
Actualpay_should_big_then_shouldpay:"Les recettes réelles ne peuvent pas être supérieures aux créances",
ShopAddress:"L'adresse de mon magasin Scannez le code QR pour passer une commande",
Submit:"soumettre",
All:"tous",
OrdernumExists:"Le numéro de commande existe déjà",
PermissionDenied:"permission refusée",
StockTransfer:"Transfert de stock",
FromWarehouse:"Transfert hors entrepôt",
ToWarehouse:"Transfert à l'entrepôt",
PleaseUseInWebBrowser:"Veuillez utiliser la fonction d'exportation Excel dans Google Chrome",
PleasePrintInWebBrowser:"Veuillez utiliser la fonction d'impression de Google Chrome",
HistoryPrice:"prix historique",
SerialNumber:"numéro de série",
Please_Use_In_APP:"Veuillez l'utiliser dans un logiciel informatique",
Please_Purchase_In_APP:"Veuillez acheter dans l'APP, pas dans le navigateur",
Connect_Postgresql_database_Default_database_is_sqlite_in_local:"Vous pouvez vous connecter à la base de données Postgresql. Vos données seront stockées dans la base de données Postgresql. Par défaut, vous n'avez pas besoin de vous connecter à la base de données Postgresql. La valeur par défaut est la base de données SQLite locale.",
Connect_Postgresql_database_data_will_store_in_Postgresql:"Connectez-vous à la base de données Postgresql, vos données seront stockées dans la base de données Postgresql et les données seront relues",
Use_sqlite_data_will_store_in_local:"En utilisant SQLite, les données seront stockées sur la machine locale",
UsePostgresqlDatabase:"Utilisation de la base de données PGSQL",
UseSqliteDatabase:"Utilisation de la base de données SQLite",
DatabaseName:"Base de données de noms",
Test_connect:"tester la connexion",
If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:"Si le produit a une couleur ou une taille, veuillez remplir 0 pour l'inventaire initial. Après avoir ajouté le produit, entrez l'inventaire lors de l'achat.",
my:"le mien",
my_shop_qrcode_scan:"Le code QR de mon magasin offre aux clients la possibilité de scanner le code pour passer commande. Le téléphone mobile du client doit être connecté au même routeur que votre ordinateur.",
ip:"IP",
port:"Port",
orderstatus:"Statut de la commande",
image:"image",
Template:"modèle",
Please_select_a_excel_file:"Veuillez sélectionner un fichier",
Please_select_only_one_excel_file:"Un seul fichier peut être sélectionné",
Connect_Internet_Login_again:"Connectez-vous à Internet et reconnectez-vous avant d'acheter",

    productHasValidDate:'Le produit a une période de validité',
productHasColor:'Le produit a la taille de la couleur',
GeneralGoods:'Marchandises générales',
Selected:'Sélectionné',
RestorePurchase:'Reprendre l’achat',
Buy_ElinkInvoice_Enterprise_Edition_OneUser:'Acheter les utilisateurs de Invoicing Enterprise Edition 1 de manière permanente',
Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'Purchase Invoicing Enterprise Edition est illimité pour les utilisateurs et les appareils',
Purchasing:'Achat ... S’il vous plaît attendez patiemment ...',
Validdate:'Période de validité',
Makedate:'Date de production',
Batch:'Lot',
CheckVersion:'Vérifier la version',
Please_set_this_ip_address_on_App:'Veuillez définir cette adresse IP ou l’adresse IP de l’ordinateur sur l’application.',
Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'Ouvrez cette connexion dans votre ordinateur ou votre navigateur mobile (connectez-vous au même réseau WiFi)',


    CheckVersion: 'Vérifier la version',
You_need_to_purchase: 'Vous n’avez pas encore acheté, ajoutez WeChat à Elink9988 E-mail: bvbuy@qq.com',
Thank_for_your_purchase: 'Vous avez déjà acheté',
New_version_available: 'Il y a une nouvelle version',
Is_the_latest_version: 'est la dernière version',
    please:'S‘il vous plaît',
input:'contribution',
wrong:'faux',
Verifycode:'Vérifier le code',
Upload:'Télécharger',
Download:'Télécharger',
You_need_to_purchase_to_continue_use:'Vous devez acheter pour continuer à utiliser',
CheckBuy:'Vérifier l’achat',
Exists:'Existe',
NetworkUnavailable:'Réseau indisponible',
Today:'Aujourd‘hui',
Yesterday:'Hier',
ThisMonth:'Ce mois-ci',
LastMonth:'Le mois dernier',
nickname:'surnom',
storeName:'nom du magasin',
BuyStandAlone:'Acheter la version autonome',
PermissionDenied:'Permission refusée',
Boss:'Boss',
    login:'S’identifier',
operate:'Fonctionner',
register:'registre',
username:'Nom d’utilisateur',
password:'Mot de passe',
User:'Utilisateur',
ok:'D’accord',
back:'Retour',
success:'Succès',
fail:'Échouer',
cancel:'Annuler',
add:'Ajouter',
edit:'modifier',
delete:'Effacer',
refresh:'Rafraîchir',
close:'Fermer',
cancel:'Annuler',
return:'Revenir',
ElinkInvoice:'Facture Elink',
Purchase:'achat',
BaseData:'Données de base',
Sell:'Vendre',
PurchaseReturns:'Retours d’achat',
SellReturns:'Vendre des retours',
Inventory:'Inventaire',
Statistics:'Statistiques',
Receivable:'Recevable',
Payable:'Payable',
Orders:'Ordres',
StockTransfer:'Transfert de stock',
StockRecall:'Rappel de stock',
Customer:'Client',
Supplier:'Fournisseur',
Warehouse:'Entrepôt',
Color:'Couleur',
Size:'Taille',
Category:'Catégorie',
Category2:'Catégorie2',
Product:'Produit',
Account:'Compte',
AccountType:'Catégorie de compte',
Staff:'Personnel',
typeone:'Catégorie',
typetwo:'Sous catégorie',
ProductName:'ProductName',
Specification:'spécification',
Barcode:'code à barre',
Buyprice:'Prix ​​d’achat',
Sellprice:'Prix ​​de vente',
Wholesaleprice:'Prix ​​de gros',
Currentstock:'Stock actuel',
Unit:'Unité',
Initstock:'Stock initial',
Parameter:'Paramètre',
Remark:'Remarque',
Supplier:'Fournisseur',
Customer:'Client',
Staff:'Personnel',
Receivable:'Recevable',
payable:'payable',
Receipts:'Recettes',
Paid:'Payé',
Preferential:'Préférentiel',
DateDay:'Rendez-vous amoureux',
OrderNum:'Numéro de commande',
Name:'prénom',
UserName:'Nom d’utilisateur',
IdNum:'Numéro d’identification',
BirthDay:'Anniversaire',
SEX:'Sexe',
Female:'Femelle',
Male:'Mâle',
Select:'Sélectionner',
Address:'Adresse',
Phone:'Téléphone',
Email:'Email',
CardNum:'Numéro de carte',
Price:'Prix',
QTY:'Qté',
SupplierCategory:'Catégorie fournisseur',
CustomerCategory:'Catégorie de client',
Power:'Puissance',
Role:'Rôle',
save:'sauvegarder',
image:'image',
search:'Chercher',
Year:'Année',
Month:'Mois',
Day:'journée',
Total:'Total',
WorkReport:'Rapport de travail',
Leave:'Laisser',
CheckIn:'Enregistrement',
Announcement:'Annonce',
Approval:'Approbation',
Tracking:'suivi',
Bill:'Facture',
OrdersDetail:'Détail des commandes',
Expense:'Frais',
Income:'le revenu',
Userfor:'Utilisateurpour',
Amount:'Montant',
Title:'Titre',
News:'Nouvelles',
SelectFile:'Choisir le dossier',
Content:'Contenu',
Cost:'Coût',
ApprovalUser:'Utilisateur d’approbation',
ApprovalStatus:'Statut approuvé',
ApprovalRemark:'Approbation Remarque',
ApprovalDate:'Date d’approbation',
SubmitDate:'Date butoire',
Status:'Statut',
FromDateTime:'De Date Heure',
ToDateTime:'À ce jour',
Subject:'Assujettir',
Latitude:'Latitude',
Longitude:'Longitude',
Print:'Impression',
DataTrans:'DataTrans',
OA:'OA',
Setting:'Réglage',
Help:'Aidez-moi',
ScanOpenInPhone:'Scan ouvert dans le téléphone',
Building:'Bâtiment',
Room:'Pièce',
HotelCheckIn:'Enregistrement',
CheckOut:'Check-out',
Hotel:'Un hôtel',
Checkintime:'Heure d’arrivée',
Checkouttime:'Heure de départ',
Deposit:'Dépôt',
Cost:'Coût',
RoomNum:'Numéro de chambre',
Rent:'Location',
costday:'costday',
rent:'location',
waternum:'Degré de l’eau',
electricnum:'Degré électrique',
gasnum:'Degré de gaz',
watercost:'coût de l’eau',
electriccost:'coût électrique',
gascost:'coût du gaz',
cleaningcost:'frais de nettoyage',
networkcost:'coût du réseau',
tvcost:'coût de la télévision',
managecost:'gérer les coûts',
othercost:'autre coût',
totalcost:'coût total',
remark:'remarque',
addtime:'Ajouter du temps',
OpenInBrowser:'Ouvrir dans le navigateur',
InventoryProfit:'Bénéfice d’inventaire',
InventoryLoss:'Perte d’inventaire',
Buy:'Acheter',




Refresh:'Actualiser',
Add:'Ajouter',
Search:'Rechercher',
Records:'enregistrements',
}



// WEBPACK FOOTER //
// ./src/lang/fr.js